export default __webpack_public_path__ + "static/media/kitAlarma2.2b750354.png";